// extracted by mini-css-extract-plugin
export default {"button":"UVMfM","link":"_1fkb4","mobileLink":"_178DS","description":"_3hpK1","expanded":"n8Zdq"};